import React from 'react';
import Home from './Home/Home';

const AllHome = () => {
    return (
        <div>
          <Home></Home>  
        </div>
    );
};

export default AllHome;